import { render } from "react-dom";
import "./assets/css/globals.css";
import { initDevServer } from "./server";
import React, { Suspense } from "react";
import { Loading } from "components";
import uuid from "react-uuid";
import "./webpack";
import { ErrorBoundary } from "react-error-boundary";
import { Error, GridOverlay } from "./components/atoms";
import "./assets/css/odometerDefault.css";

/** For Development we need to fetch data from a mock server, CORS issues. */
if (process.env.NODE_ENV === "development") {
  initDevServer()
}

const LazySubPage = React.lazy(() => import("./components/templates/subpage/index"));
const LazyShowCasePage = React.lazy(() => import("./components/templates/showcase/index"));

const pages = ["subpage", "showcase"]; // list of all pages 

/**
 * There will only be one matching div at any given time
*/
const activePage = pages.map(i => document.getElementById(i)).filter(Boolean)[0];

/**
* Storing our Applications in a dictionary for dynamic rendering
*/
const Apps = {
  subpage: function SubPageApp() {
    return (
      <div id="App" className="App">
          <LazySubPage id={uuid()} />
      </div>
    );
  },
  showcase: function ShowcasePageApp() {
    return (
      <div id="App" className="App">
          <LazyShowCasePage />
      </div>
    );
  }
}

const ActiveApp = () => (
  <Suspense fallback={<Loading />}>
    <GridOverlay />
    {Apps[activePage.id]()}
  </Suspense>
);


render(<ActiveApp />, activePage);
